import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Axios from 'axios'
import { getDeviceId } from './Utils/deviceId'

import VueFormWizard from 'vue-form-wizard'
import Vuelidate from 'vuelidate'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import VueTabs from 'vue-nav-tabs/dist/vue-tabs'
import * as VueGoogleMaps from 'vue2-google-maps'
import VCalendar from 'v-calendar';
import sanitizeHTML from 'sanitize-html';
import vueSmoothScroll from 'vue2-smooth-scroll'
import Toasted from 'vue-toasted'

import VueI18n from 'vue-i18n';
import messages from './lang';

import 'dotenv/config';

import '@fortawesome/fontawesome-free/css/all.css'

import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-nav-tabs/themes/vue-tabs.css'
import '@/styles.css';
import '@/new-assets/responsive.css';

import { mask } from "vue-the-mask";
import filters from './Utils/filters';
import { checkAppVersion } from './appVersionCheck'
import { saveRedirectUrl } from './Utils/Utils'
import { iniciarNotificaciones, conectarToasted } from './Utils/notificaciones'

import injectInitialState from './Utils/inject_initial_state';
import DefaultLayout from "@/layouts/DefaultLayout.vue";

Vue.component('DefaultLayout', DefaultLayout);

Vue.use(BootstrapVue);
Vue.use(VueFormWizard);
Vue.use(Vuelidate);
Vue.use(VueTabs);
Vue.use(vueSmoothScroll);
Vue.use(Toasted);

Vue.directive('mask', mask);

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCevwnAx6XUOYAwNnp8BXcvg8FPj2nXqMQ',
        libraries: 'places',
        v: '3.55.11a',
    },
    installComponents: true
})

// La API de Google Maps se cargaba dos veces: una desde el <script> de
// index.html y otra desde vue2-google-maps, que inyecta la suya sin fijarse en
// window.google (ver node_modules/vue2-google-maps/src/manager.js). Las dos
// URLs solo difieren en el parametro `callback`, asi que la segunda era un
// cache miss: 388 kB descargados de nuevo.
//
// Peor todavia, vue2-google-maps carga de forma lazy, recien al montar el
// primer componente Gmap*. Como el mapa de la ficha vive detras de un v-if, esa
// descarga arrancaba al hacer clic en la pestania "Mapa" y el usuario miraba un
// recuadro en blanco hasta que terminaba (2,79 s medidos en produccion).
//
// Ahora la carga es una sola y se dispara aca, al arrancar la app, para que ya
// este lista cuando alguien abre un mapa. El <script> de index.html se quito.
// `window.googleMapsLoaded` se mantiene porque ya la consumen SearchResults,
// WizardPropiedad, CargaMasiva y
// AccommodationCharges.
window.googleMapsLoaded = Vue.$gmapApiPromiseLazy()

Vue.use(VCalendar, {
    firstDayOfWeek: 2,  // Monday
});

Vue.prototype.$http = Axios;
Vue.prototype.$sanitize = sanitizeHTML;

// Add the token
const token = localStorage.getItem('token')
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

// Id del dispositivo en los pedidos que escriben a NUESTRA API, para el
// historial de accesos y de cambios de alojamientos. Solo a la API propia: un
// header desconocido hace fallar el CORS de cualquier otro dominio.
Vue.prototype.$http.interceptors.request.use(function(config) {
    const apiBase = process.env.VUE_APP_API_URL || '';
    const metodo = (config.method || 'get').toLowerCase();
    if (apiBase && metodo !== 'get' && String(config.url || '').indexOf(apiBase) === 0) {
        config.headers = config.headers || {};
        config.headers['X-Device-Id'] = getDeviceId();
    }
    return config;
});

// Check the app version
Vue.prototype.$http.interceptors.response.use(function(res) {
    checkAppVersion(res);
    return res;
}, function(error) {
    cerrarSiSesionVencida(error);
    return Promise.reject(error);
});

// Sesión vencida (10 h sin uso, ver AuthServiceProvider en hyf-api): la API
// contesta 401 con code SESION_VENCIDA. Se cierra la sesión del dispositivo y
// se manda al login, que después vuelve a la página donde estaba. Solo con ese
// código: la API tiene otros 401 (permisos, pagos) que no son de sesión.
const MENSAJE_SESION_VENCIDA = {
    es: 'Tu sesión venció. Inicia sesión de nuevo.',
    en: 'Your session has expired. Please sign in again.',
    pt: 'Sua sessão expirou. Entre novamente.',
    fr: 'Votre session a expiré. Veuillez vous reconnecter.',
    it: 'La tua sessione è scaduta. Accedi di nuovo.',
    de: 'Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.'
};
let cerrandoSesion = false;
function cerrarSiSesionVencida(error) {
    const res = error && error.response;
    if (!res || res.status !== 401 || !res.data || res.data.code !== 'SESION_VENCIDA') return;
    // Sin token no hay nada que cerrar; y varios pedidos fallan juntos: un solo cierre.
    if (cerrandoSesion || !localStorage.getItem('token')) return;
    cerrandoSesion = true;

    const actual = router.currentRoute;
    if (actual && actual.name !== 'login' && actual.name !== 'register') {
        saveRedirectUrl(actual);
    }
    store.dispatch('logout', { destino: { name: 'login' } });

    // Después del cierre: al desloguear, Utils/notificaciones vacía los carteles
    // (en el próximo tick), y si se mostrara ya, se borraría en el acto.
    const idioma = (i18n && i18n.locale) || 'es';
    setTimeout(function() {
        Vue.toasted.show(MENSAJE_SESION_VENCIDA[idioma] || MENSAJE_SESION_VENCIDA.es, {
            type: 'info', duration: 8000
        });
    }, 300);
    // Se libera al rato para que una sesión nueva que vuelva a vencer también se cierre.
    setTimeout(function() { cerrandoSesion = false; }, 3000);
}

Vue.config.productionTip = false

Vue.use(VueI18n);
export const i18n = new VueI18n({
    locale: navigator.language.split('-')[0], // Set the browser language as default
    fallbackLocale: 'es',
    messages
});


const GoogleSignInButton = Vue.directive('google-signin-button', {
    bind: function (el, binding, vnode) {
        CheckComponentMethods()
        let clientId = binding.value
        let googleSignInAPI = document.createElement('script')
        googleSignInAPI.setAttribute('src', 'https://apis.google.com/js/api:client.js')
        document.head.appendChild(googleSignInAPI)

        googleSignInAPI.onload = InitGoogleButton

        function InitGoogleButton() {
            gapi.load('auth2', () => {
                const auth2 = gapi.auth2.init({
                    client_id: clientId,
                    cookiepolicy: 'single_host_origin'
                })
                auth2.attachClickHandler(el, {},
                    OnSuccess,
                    Onfail
                )
            })
        }
        function OnSuccess(googleUser) {
            vnode.context.OnGoogleAuthSuccess(googleUser.getBasicProfile())
            googleUser.disconnect()
        }
        function Onfail(error) {
            vnode.context.OnGoogleAuthFail(error)
        }
        function CheckComponentMethods() {
            if (!vnode.context.OnGoogleAuthSuccess) {
                throw new Error('The method OnGoogleAuthSuccess must be defined on the component')
            }

            if (!vnode.context.OnGoogleAuthFail) {
                throw new Error('The method OnGoogleAuthFail must be defined on the component')
            }
        }
    }
})

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

const app = new Vue({
    GoogleSignInButton,
    router,
    store,
    i18n,
    created() {
    },
    render: h => h(App)
})

if (window.__INITIAL_STATE__) store.replaceState(window.__INITIAL_STATE__)

router.beforeResolve(async (to, from, next) => {
    try {
        const components = router.getMatchedComponents(to)
        await Promise.all(components.map(x => x.fetch && x.fetch({ store })))

        if (window.__PRERENDER_INJECTED) injectInitialState(store.state)
    } catch (error) {
        console.log(error)
    }
    return next()
})

app.$mount('#app');

// Notificaciones en vivo (campana del header): siguen a la sesión.
iniciarNotificaciones({ store, router, i18n });
// Los avisos de vue-toasted ($toasted) salen con el mismo cartel que las notificaciones.
conectarToasted(Vue);
